import React, {type FC} from 'react';
import {IProduct} from '../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';
import {ProductQuickAddMobile} from './ProductQuickAddMobile/ProductQuickAddMobile';
import {ProductQuickAddDesktop} from './ProductQuickAddDesktop/ProductQuickAddDesktop';
import {useQuickAddOptions} from './hooks/useQuickAddOptions';
import {useShouldHideQuickAddInEditor} from './hooks/useShouldHideQuickAddInEditor';

export interface IProductQuickAddProps {
  product: IProduct;
  productIndex: number;
  productItemRef: React.RefObject<HTMLDivElement>;
  quantity: number;
}

const ProductQuickAddComp: FC<IProductQuickAddProps> = ({product, productIndex, productItemRef, quantity}) => {
  const {shouldShowMobile} = useGlobals();
  const quickAddOptions = useQuickAddOptions(product.options);
  const shouldHideInEditor = useShouldHideQuickAddInEditor(product, quickAddOptions.length);

  if (shouldHideInEditor) {
    return null;
  }

  return shouldShowMobile ? (
    <ProductQuickAddMobile
      product={product}
      options={quickAddOptions}
      quantity={quantity}
      productIndex={productIndex}
    />
  ) : (
    <ProductQuickAddDesktop
      product={product}
      options={quickAddOptions}
      quantity={quantity}
      productIndex={productIndex}
      productItemRef={productItemRef}
    />
  );
};

export const ProductQuickAdd = withGlobals(ProductQuickAddComp);
